import "../../scss/pages/home.scss";
import ModalDownloadMobileApp from "../components/modal-download-mobile-app";

document.addEventListener("DOMContentLoaded", function () {
	const buttonBarometerList = document.querySelectorAll('.card-barometer .btn-barometer');
	const main = document.querySelector('.container-page');
	
	if (((sessionStorage.getItem('modalDownloadAppShown') !== 'true') && main) && ((main.dataset.deviceType === 'Mobile Device') || (main.dataset.deviceType === 'Mobile Phone'))) {
		import('../components/modal')
			.then((module) => {
				
				const params = {
					deviceType: main.dataset.deviceType
				}
				const modalModule = new module.Modal();
				modalModule.openModal('modal-download-mobile-app modal-auth modal-slide-up', 'modalDownloadMobileApp', './modal/modal-download-mobile-app', params, ModalDownloadMobileApp.handleOnOpen, ModalDownloadMobileApp.activeSession);
			})
	}
	
	buttonBarometerList.forEach((buttonBarometer) => {
		buttonBarometer.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'homePage', buttonBarometer.dataset.tag]);
			/* eslint-enable */
		})
	});
	
});